export { default as DrawArea } from './component'
